import axios from 'axios';
import authHeader from './AuthHeader';
import { AppConstants } from '../constants/AppConstants';
import JobApplicationEntity from "../types/jobApplicationEntity.type";

class JobsService {
  getJobApplicationsBoard() {
    return axios.get(AppConstants.API_URL + '/job-applications', { headers: authHeader() });
  }

  getUserJobApplications(userId: number | undefined) {
    return axios.get(AppConstants.API_URL + '/my-applications?userId=' + userId, { headers: authHeader() });
  }
  getJobApplication(jobApplicationId: number | undefined) {
    return axios.get(AppConstants.API_URL + '/job-application?id=' + jobApplicationId, { headers: authHeader() });
  }
  updateJobApplication(delivery: JobApplicationEntity) {
    if (delivery.id == null) throw new Error("Delivery ID is required");
    return axios.put(AppConstants.API_URL + '/deliveries/' + delivery.id, delivery, {
      headers: authHeader(),
    });
  }

  deleteJobApplication(jobApplicationId: number) {
    return axios.delete(AppConstants.API_URL + '/job-application/' + jobApplicationId, {
      headers: authHeader(),
    });
  }
}

export default new JobsService();